import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IMAGE_SIZES } from '@shared/classes/image.class';
import { ProductItem } from '@shared/classes/product-item.class';
import { IInventoryEvent } from '@shared/interfaces/inventory-event.interface';
import { ImageLoaderCapComponentModule } from '../image-loader-cap/image-loader-cap.component';
import { TranslateModule } from '@ngx-translate/core';
import { ImageUrlPipeModule } from '@shared/pipes';
import { NgForTrackByUuidDirectiveModule } from '@shared/directives';

@Component({
  selector: 'pos-product-search-list',
  templateUrl: './product-search-list.component.html',
  styleUrls: ['./product-search-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductSearchListComponent {
  @Input() productItems: ProductItem[] = [];
  @Input() placeholderNoResult = 'inventory_search_no_products';
  @Input() showActiveProduct = false;
  @Input() activeProductItem: ProductItem;
  @Output() posProductLongClick = new EventEmitter<ProductItem>();
  @Output() posProductClick = new EventEmitter<IInventoryEvent>();

  private longClickTimer: ReturnType<typeof setTimeout>;
  private longClickFired = false;

  get IMAGE_SIZES() {
    return IMAGE_SIZES;
  }

  productLongClick(productItem: ProductItem) {
    this.posProductLongClick.emit(productItem);
  }

  // Replaces Hammer's (press), which stopped firing when hammerjs was removed; 500 ms as the grid long-press.
  startLongClick(productItem: ProductItem) {
    this.longClickFired = false;
    this.cancelLongClick();
    if (!this.posProductLongClick.observed) {
      return;
    }
    this.longClickTimer = setTimeout(() => {
      this.longClickFired = true;
      this.productLongClick(productItem);
    }, 500);
  }

  cancelLongClick() {
    clearTimeout(this.longClickTimer);
  }

  productClick(productItem: ProductItem, eventTarget: any) {
    // The release of a long-press can still produce a click; it must not add the product as well.
    if (this.longClickFired) {
      this.longClickFired = false;
      return;
    }
    if (this.activeProductItem && this.activeProductItem.uuid === productItem.uuid) {
      return;
    }
    this.posProductClick.emit({ dataset: productItem, eventTarget });
    if (this.showActiveProduct) {
      this.activeProductItem = productItem;
    }
  }
}
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
    ImageLoaderCapComponentModule,
    ImageUrlPipeModule,
    NgForTrackByUuidDirectiveModule,
  ],
  declarations: [ProductSearchListComponent],
  exports: [ProductSearchListComponent],
})
export class ProductSearchListComponentModule {}
